import { ref, watch } from 'vue'

const KEY = 'kedo:nav:sections'
const DEFAULTS = { documents: true, knowledge: true, settings: true, services: true }

function load() {
    try {
        return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) ?? '{}') }
    } catch (err) {
        console.warn('useNavSections: corrupt localStorage, resetting to defaults', err)
        return { ...DEFAULTS }
    }
}

const state = ref(load())
watch(state, v => localStorage.setItem(KEY, JSON.stringify(v)), { deep: true })

export function useNavSections() {
    return { sections: state, toggle: (k) => { state.value[k] = !state.value[k] } }
}
